import { useEffect, useState } from "react";

// --------------------- Import Antd-Design ---------------------
import { Card, Modal, Skeleton } from "antd";

// --------------------- Import Styles ---------------------
import { Title } from "../styles";

// --------------------- Import Hooks ---------------------
import { useExcluirEmpreendimento } from "../hooks/useExcluirEmpreendimento";

// --------------------- Import Uteis ---------------------
import { useMessage } from "../../../uteis/mensagens/useMessage";

// --------------------- Import Interfaces ---------------------
import { ModalEmpreendProps } from "../interfaces/ModalEmpreendProps";

export default function ModalExcluir({
  isModalOpen,
  handleFechar,
  empreendId,
  buscar,
}: ModalEmpreendProps) {
  const {
    excluirEmpreend,
    isLoading,
    error,
    success,
    warning,
    resetError,
    resetSuccess,
    resetWarning,
  } = useExcluirEmpreendimento();

  // Exibe a Mensagem de Retorno
  const { showSuccess, showError, showWarning, contextHolder } = useMessage();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [warningDisplayed, setWarningDisplayed] = useState(false);

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        setSuccessDisplayed(false);
        resetSuccess();
        handleFechar();
        buscar?.();
      }, 2000);
    }

    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }

    if (warning && !warningDisplayed) {
      showWarning(warning);
      setWarningDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setWarningDisplayed(false);
        resetWarning();
      }, 3000);
    }
  }, [
    isModalOpen,
    success,
    successDisplayed,
    showSuccess,
    resetSuccess,
    error,
    errorDisplayed,
    showError,
    resetError,
    warning,
    warningDisplayed,
    showWarning,
    resetWarning,
    handleFechar,
    buscar,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        cancelText="Cancelar"
        okText="Excluir"
        onCancel={handleFechar}
        confirmLoading={isLoading}
        onOk={() => excluirEmpreend(empreendId)}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {isLoading && <Skeleton active />}
        {!isLoading && (
          <>
            <>{contextHolder}</>
            <Card
              title={<Title>Excluir</Title>}
              style={{
                width: "100%",
                marginTop: "20px",
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <>
                <h1>
                  Você tem certeza que deseja excluir esse empreendimento?
                </h1>
              </>
            </Card>
          </>
        )}
      </Modal>
    </>
  );
}
